import React, { useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Page, PageErrorState } from 'seagull';
import { FunctionalLoader } from 'seagull';
import { useStore, useStoreActions } from "../../store/store-context";
import { useQboIntegration } from "../../hooks/useQboIntegration";
import { useLocation } from "../../providers/LocationProvider";
import { routes } from "../../constants";
import QboCard from "./QboCard/QboCard";
import { QboSetupPage } from "./QboSetupPage/QboSetupPage";
import PostConnectionModal from "../QBO/PostConnectionModal/PostConnectionModal";
import ZapierCard from "./ZapierCard/ZapierCard";
import styles from "./IntegrationsPage.module.scss";
import SlackViaZapierCard from "./SlackViaZapierCard/SlackViaZapierCard";
import SlackViaZapierPage from "./SlackViaZapierPage/SlackViaZapierPage";
import { integrationModel } from "../../models";
import FinancialCentsCard from "./FinancialCentsCard/FinancialCentsCard";
import PMSetupPage from "../PracticeManagement/PMSetupPage/PMSetupPage";
import KarbonCard from "./KarbonCard/KarbonCard";
import { IntegrationSource } from "../../types/api.model";
import ClientHubCard from "./ClientHubCard/ClientHubCard";
const title = 'Integrations';
const subheader = 'Manage your integrations';
export function IntegrationsPage() {
  const {
    fetchIntegrations
  } = useStoreActions();
  const {
    data: integrations,
    error
  } = useStore(state => state.integrations);
  const [isLoading, setIsLoading] = useState(true);
  const {
    api,
    fetchKarbonItems,
    fetchClientHubItems,
    fetchFinancialCentsItems
  } = useStoreActions();
  const {
    connectToQbo
  } = useQboIntegration();
  const location = useLocation();
  const karbonIntegration = integrationModel.karbonIntegration(integrations);
  const clientHubIntegration = integrationModel.clientHubIntegration(integrations);
  const financialCentsIntegration = integrationModel.financialCentsIntegration(integrations);
  useEffect(() => {
    document.title = title;
  }, []);
  useEffect(() => {
    fetchIntegrations().then(() => setIsLoading(false));
  }, [location.pathname]);
  const handleConnectToQbo = async () => {
    setIsLoading(true);
    const newIntegration = await connectToQbo();
    const linkUrl = newIntegration === null || newIntegration === void 0 ? void 0 : newIntegration.linkUrl;
    if (linkUrl) {
      const connectUrl = new URL(linkUrl);
      connectUrl.searchParams.append('host', window.location.host);
      if (location.assign) location.assign(connectUrl.toString());
    } else {
      await fetchIntegrations();
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: routes.qboSetup,
    component: QboSetupPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.slackIntegration,
    component: SlackViaZapierPage
  }), financialCentsIntegration && integrationModel.isLinked(financialCentsIntegration) && /*#__PURE__*/React.createElement(Route, {
    path: routes.financialCentsSetup,
    render: () => /*#__PURE__*/React.createElement(PMSetupPage, {
      testid: "financial-cents-setup",
      pmName: IntegrationSource.FinancialCents,
      doDisconnect: api.financialCents.disconnect,
      getItems: fetchFinancialCentsItems,
      linkServiceTemplate: api.financialCents.linkServiceTemplate,
      getServiceTemplateIntegratedIds: template => template.integrations.financialCentsIntegratedIds()
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.karbonSetup,
    render: () => /*#__PURE__*/React.createElement(PMSetupPage, {
      testid: "karbon-setup",
      pmName: IntegrationSource.Karbon,
      doDisconnect: api.karbon.disconnect,
      getItems: fetchKarbonItems,
      linkServiceTemplate: api.karbon.linkServiceTemplate,
      integration: karbonIntegration,
      getServiceTemplateIntegratedIds: template => template.integrations.karbonIntegratedIds()
    })
  }), clientHubIntegration && /*#__PURE__*/React.createElement(Route, {
    path: routes.clientHubSetup,
    render: () => /*#__PURE__*/React.createElement(PMSetupPage, {
      testid: "client-hub-setup",
      pmName: IntegrationSource.ClientHub,
      doDisconnect: api.clientHub.disconnect,
      getItems: fetchClientHubItems,
      linkServiceTemplate: api.clientHub.linkServiceTemplate,
      integration: clientHubIntegration,
      getServiceTemplateIntegratedIds: template => template.integrations.clientHubIntegratedIds()
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.integrations
  }, error ? /*#__PURE__*/React.createElement(PageErrorState, {
    "data-testid": "integrations-error-state",
    title: title,
    onRefresh: () => fetchIntegrations()
  }) : /*#__PURE__*/React.createElement(Page, {
    "data-testid": "integrations-page",
    header: title,
    subheader: subheader
  }, isLoading && /*#__PURE__*/React.createElement(FunctionalLoader, {
    show: isLoading,
    name: "loadingIntegrations"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.cardsContainer
  }, !!integrations && /*#__PURE__*/React.createElement(QboCard, {
    connect: handleConnectToQbo
  }), /*#__PURE__*/React.createElement(ZapierCard, null), financialCentsIntegration && /*#__PURE__*/React.createElement(FinancialCentsCard, {
    integration: financialCentsIntegration
  }), karbonIntegration && /*#__PURE__*/React.createElement(KarbonCard, {
    integration: karbonIntegration
  }), clientHubIntegration && /*#__PURE__*/React.createElement(ClientHubCard, {
    integration: clientHubIntegration
  }), /*#__PURE__*/React.createElement(SlackViaZapierCard, null))), /*#__PURE__*/React.createElement(Route, {
    path: routes.postIntegrationConnection,
    render: () => /*#__PURE__*/React.createElement(PostConnectionModal, null)
  })));
}